import { apiFacilityAssignmentPlan } from './apiFacilityAssignmentPlan'
import { apiDemandOrders } from './apiDemandOrders'

export const apiDemandPlanning = {
	...apiFacilityAssignmentPlan,
	...apiDemandOrders,
}
